/** Everything the person can pick from. Adding an option = add an id here, a builder/animation for it, and a label. */

export interface Option<Id extends string> {
    id: Id;
    label: string;
    emoji: string;
}

export type ModelId = 'classic' | 'timer';
export type EyesId = 'none' | 'googly' | 'angry' | 'shades' | 'hearts';
export type MouthId = 'none' | 'smile' | 'tongue' | 'mustache';
export type HatId = 'none' | 'party' | 'tophat' | 'crown' | 'wizard';
export type NeckId = 'none' | 'tshirt' | 'pearls' | 'bling';
export type BackgroundId = 'default' | 'beach' | 'space' | 'farm';
export type VineId = 'classic' | 'ivy' | 'blossom';
export type CompletionId = 'explode' | 'roll' | 'rocket';

export const MODELS: Option<ModelId>[] = [
    { id: 'classic', label: 'Classic', emoji: '🍅' },
    { id: 'timer', label: 'Kitchen timer', emoji: '⏰' },
];

export const EYES: Option<EyesId>[] = [
    { id: 'none', label: 'None', emoji: '🚫' },
    { id: 'googly', label: 'Googly', emoji: '👀' },
    { id: 'angry', label: 'Angry', emoji: '😠' },
    { id: 'shades', label: 'Shades', emoji: '😎' },
    { id: 'hearts', label: 'Hearts', emoji: '😍' },
];

export const MOUTHS: Option<MouthId>[] = [
    { id: 'none', label: 'None', emoji: '🚫' },
    { id: 'smile', label: 'Smile', emoji: '🙂' },
    { id: 'tongue', label: 'Tongue', emoji: '😛' },
    { id: 'mustache', label: 'Mustache', emoji: '🥸' },
];

export const HATS: Option<HatId>[] = [
    { id: 'none', label: 'None', emoji: '🚫' },
    { id: 'party', label: 'Party', emoji: '🥳' },
    { id: 'tophat', label: 'Top hat', emoji: '🎩' },
    { id: 'crown', label: 'Crown', emoji: '👑' },
    { id: 'wizard', label: 'Wizard', emoji: '🧙' },
];

export const NECKLACES: Option<NeckId>[] = [
    { id: 'none', label: 'None', emoji: '🚫' },
    { id: 'tshirt', label: 'T-shirt', emoji: '👕' },
    { id: 'pearls', label: 'Pearls', emoji: '📿' },
    { id: 'bling', label: '2ma2 bling', emoji: '💎' },
];

export const BACKGROUNDS: Option<BackgroundId>[] = [
    { id: 'default', label: 'Glow', emoji: '🍅' },
    { id: 'beach', label: 'Beach', emoji: '🏖️' },
    { id: 'space', label: 'Space', emoji: '🪐' },
    { id: 'farm', label: 'Farm', emoji: '🌾' },
];

export const VINES: Option<VineId>[] = [
    { id: 'classic', label: 'Classic', emoji: '🌿' },
    { id: 'ivy', label: 'Ivy', emoji: '🍃' },
    { id: 'blossom', label: 'Blossom', emoji: '🌼' },
];

export const COMPLETIONS: (Option<CompletionId> & { blurb: string })[] = [
    {
        id: 'explode',
        label: 'Explode',
        emoji: '💥',
        blurb: 'Splat! Bits and accessories everywhere.',
    },
    {
        id: 'roll',
        label: 'Roll away',
        emoji: '🛞',
        blurb: 'Rolls off screen, a fresh one rolls in.',
    },
    {
        id: 'rocket',
        label: 'Rocket',
        emoji: '🚀',
        blurb: 'Blasts off into orbit.',
    },
];

export const SWATCHES = [
    '#e63a2a',
    '#ff6b35',
    '#ffb703',
    '#8ac926',
    '#2ec4b6',
    '#3a86ff',
    '#8338ec',
    '#ff5fa2',
    '#f1f1f1',
    '#2b2d42',
];

export interface Look {
    model: ModelId;
    color: string;
    eyes: EyesId;
    mouth: MouthId;
    hat: HatId;
    vine: VineId;
    neck: NeckId;
    background: BackgroundId;
    /** Tint of the plain Glow background; empty follows the tomato's colour. */
    glowColor?: string;
}

export const DEFAULT_LOOK: Look = {
    model: 'classic',
    color: '#e63a2a',
    eyes: 'googly',
    mouth: 'smile',
    hat: 'none',
    vine: 'classic',
    neck: 'none',
    background: 'default',
};
